export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/business_finance_law.16ef337.svg";